export enum ApiLoadingStateEnum {
  failed = 'failed',
  idle = 'idle',
  loading = 'loading',
  succeeded = 'succeeded',
}
